import { ReportInfoSagas } from './Reports'

export default [
    ...ReportInfoSagas
]